import React from 'react';
import './LegalPages.css';

function ContactPage() {
  return (
    <div className="legal-page">
      <div className="legal-hero">
        <h1>Contact Us</h1>
        <p className="last-updated">We'd love to hear from you</p>
      </div>

      <div className="legal-content">
        <section className="legal-section">
          <h2>Get in Touch</h2>
          <p>Have questions, feedback, or need assistance? Reach out to us through any of the following channels:</p>
        </section>

        <section className="legal-section">
          <h2>Contact Information</h2>
          <div className="contact-grid">
            <div className="contact-item">
              <div className="contact-icon">📧</div>
              <h3>Email</h3>
              <p><strong>General Inquiries:</strong><br/>info@discovervanuatu.com</p>
              <p><strong>Business Listings:</strong><br/>business@discovervanuatu.com</p>
              <p><strong>Advertising:</strong><br/>ads@discovervanuatu.com</p>
              <p><strong>Technical Support:</strong><br/>support@discovervanuatu.com</p>
            </div>

            <div className="contact-item">
              <div className="contact-icon">📞</div>
              <h3>Phone</h3>
              <p><strong>Main Office:</strong><br/>+678 25 123</p>
              <p><strong>Business Support:</strong><br/>+678 25 456</p>
              <p className="note">Available Monday - Friday<br/>9:00 AM - 5:00 PM (Vanuatu Time)</p>
            </div>

            <div className="contact-item">
              <div className="contact-icon">📍</div>
              <h3>Address</h3>
              <p><strong>Discover Vanuatu</strong><br/>
              Port Vila<br/>
              Vanuatu</p>
            </div>

            <div className="contact-item">
              <div className="contact-icon">🌐</div>
              <h3>Social Media</h3>
              <p>Follow us for updates and news:</p>
              <p>
                <strong>Facebook:</strong> @DiscoverVanuatu<br/>
                <strong>Instagram:</strong> @DiscoverVanuatu<br/>
                <strong>Twitter:</strong> @DiscoverVanuatu
              </p>
            </div>
          </div>
        </section>

        <section className="legal-section">
          <h2>Business Listing Inquiries</h2>
          <p>Are you a business owner looking to be featured on Discover Vanuatu? We offer various listing options to help you reach more customers:</p>
          <ul>
            <li><strong>Free Basic Listings:</strong> Get your business on our platform at no cost</li>
            <li><strong>Premium Listings:</strong> Enhanced visibility with featured placement</li>
            <li><strong>Advertisement Campaigns:</strong> Targeted ads to reach your ideal customers</li>
          </ul>
          <p>Contact our business team at <strong>business@discovervanuatu.com</strong> to learn more.</p>
        </section>

        <section className="legal-section">
          <h2>Technical Support</h2>
          <p>Experiencing technical issues with our website or mobile app? Our support team is here to help:</p>
          <ul>
            <li>Email: <strong>support@discovervanuatu.com</strong></li>
            <li>Please include detailed information about the issue, including screenshots if possible</li>
            <li>We typically respond within 1-2 business days</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Feedback and Suggestions</h2>
          <p>Your feedback helps us improve Discover Vanuatu. We welcome your suggestions, comments, and ideas for making our platform better serve the Vanuatu community.</p>
          <p>Send your feedback to: <strong>feedback@discovervanuatu.com</strong></p>
        </section>

        <section className="legal-section">
          <h2>Report an Issue</h2>
          <p>If you notice incorrect business information, inappropriate content, or any concerns about our platform, please let us know:</p>
          <ul>
            <li><strong>Incorrect Information:</strong> business@discovervanuatu.com</li>
            <li><strong>Inappropriate Content:</strong> report@discovervanuatu.com</li>
            <li><strong>Privacy Concerns:</strong> privacy@discovervanuatu.com</li>
          </ul>
        </section>

        <section className="legal-section disclaimer">
          <h2>Response Time Disclaimer</h2>
          <p><strong>Please Note:</strong> While we strive to respond to all inquiries promptly, Discover Vanuatu has no obligation to respond within any specific timeframe or at all. Response times may vary depending on the volume of inquiries and the nature of your request. We appreciate your patience and understanding.</p>
        </section>
      </div>
    </div>
  );
}

export default ContactPage;
